import {useState, useEffect} from 'react'
/** @jsxImportSource @emotion/react */
import {css, keyframes} from '@emotion/react'
import Avatar from '@mui/material/Avatar'

// fade‑in animation
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px) }
  to   { opacity: 1; transform: translateY(0) }
`

const tickerStyle = css`
  position: absolute;
  top: -30px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  pointer-events: none;
  padding-left: 20px;
`

const itemStyle = css`
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.4);
  color: #fff;
  padding: 8px 20px;
  border-radius: 9999px;
  animation: ${fadeIn} 0.6s ease-out;
`

const textStyle = css`
  margin-left: 10px;
  font-size: 0.9rem;
`


const pastelColors = [
  '#FFCDD2', '#F8BBD0', '#E1BEE7', '#D1C4E9',
  '#C5CAE9', '#BBDEFB', '#B3E5FC', '#B2EBF2',
  '#B2DFDB', '#C8E6C9', '#DCEDC8', '#F0F4C3',
  '#FFF9C4', '#FFECB3', '#FFE0B2', '#FFDAB9'
]



// simple hash→emoji as before
const emojiList = ['🎉','🎵','🎤','🎸','🥁','🪕','🎻','🎺','🎹','🎷']
function hashCode(str) {
  return Array.from(str).reduce((h, c) => h + c.charCodeAt(0), 0)
}

function getEmoji(id) {
  return emojiList[hashCode(id) % emojiList.length]
}

function getColor(id) {
  return pastelColors[hashCode(id) % pastelColors.length]
}



const CommentCycler = ({ items, interval = 5000 }) => {
  const [idx, setIdx] = useState(0)

  useEffect(() => {
    if (!items.length) return
    const timer = setInterval(
      () => setIdx(i => (i + 1) % items.length),
      interval
    )
    return () => clearInterval(timer)
  }, [items.length, interval])

  if (!items.length) return null
  const {id, comment, src, name} = items[idx]


  return (
    <div css={tickerStyle}>
      {/* Key on this div forces a fresh mount & fadeIn */}
      <div key={id} css={itemStyle}>
        <Avatar
          src={src || undefined}
          alt={name}
          sx={{
            width: 30,
            height: 30,
            bgcolor: src ? undefined : getColor(id)
          }}
        >
          {!src && getEmoji(id)}
        </Avatar>
        <span css={textStyle}>{comment}</span>
      </div>
    </div>
  )
}

export default CommentCycler


